import * as types from "../actions/actionTypes";

const initialState = {
  states: [],
  state: null,
};

const state = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_STATE_RESPONSE:
      return { ...state, states: action.payload };
    case types.GET_STATE_RESPONSE:
      return { ...state, states: action.payload };

    case types.CREATE_STATE:
      return { ...state, state: null };
    case types.UPDATE_STATE:
      return { ...state, state: null };
    case types.DELETE_STATE:
      return { ...state, state: null };
    default:
      return state;
  }
};

export default state;
